export const ZOOM_STEP = 1.1;
export const MIN_ZOOM = 0.25;
export const MAX_ZOOM = 4;

export function clampZoom(value: number): number {
  if (!Number.isFinite(value)) return 1;
  return Math.min(MAX_ZOOM, Math.max(MIN_ZOOM, value));
}

export function zoomIn(value: number): number {
  return clampZoom(value * ZOOM_STEP);
}

export function zoomOut(value: number): number {
  return clampZoom(value / ZOOM_STEP);
}

export function zoomPercentLabel(value: number): string {
  return `${Math.round(clampZoom(value) * 100)}%`;
}
